import type { SimulationDependency } from '../../simulation.types'
import { getTaskDependencies } from '../getTaskDependencies'

/** The tasks fetched with a value that came off this one. */
export const getTasksDependingOn = ({
  taskReferenceName,
  dependencies
}: {
  taskReferenceName: string
  dependencies: SimulationDependency[]
}): string[] =>
  dependencies
    .filter(dependency =>
      getTaskDependencies(dependency.task).includes(taskReferenceName)
    )
    .map(dependency => dependency.task.taskReferenceName)
